import styled from 'styled-components'

export const StyledImage = styled.img`
  width: ${({ size, width }) => size || width || '100%'};
  height: ${({ height }) => height || 'auto'};
  border-radius: ${({ shape }) => shape === 'circle' ? '50%' : 'none'};
  background: ${({ shape }) => shape === 'circle' ? ' #fdfdfd' : 'none'};
  background-color: ${({ bgColor }) => bgColor || ''};
  max-width: 100%;
  @media (orientation:portrait) {
    max-width: 100%;
    flex-direction: column;
    align-items: center;
    display: flex;
    width: ${({ size, width }) => size || width || '100%'};
    height: ${({ height }) => height || 'auto'};
  }
`
